// En la demostración estática el enrutador usa el hash (#/preventa/...) para funcionar sin reescritura en el servidor.
export const hrefRuta = (ruta: string) => (import.meta.env.VITE_DEMO ? `#${ruta}` : ruta);
